/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { availabilityRangeBulkCreateItemSchema } from './availabilityRangeBulkCreateItemSchema';

export const availabilityRangeBulkCreateRequestSchema = z.object({
  get ranges() {
    return z.array(availabilityRangeBulkCreateItemSchema).min(0).max(500);
  },
});
